import React from 'react';
import PropTypes from 'prop-types';
// import './Rectangle.css';

const Rectangle = ({ className, width, height, topLeft, topRight, bottomLeft, bottomRight, background, children }) => {
  const style = {
    position: 'relative',
    width: width,
    height: height,
    clipPath: `polygon(
      ${topLeft.x}% ${topLeft.y}%, 
      ${topRight.x}% ${topRight.y}%, 
      ${bottomRight.x}% ${bottomRight.y}%, 
      ${bottomLeft.x}% ${bottomLeft.y}%
    )`,
    background: background
  };

  const borderStyle = {
    position: 'absolute',
    top: '-1px', // Adjust to ensure the border is visible on all sides
    left: '-1px', // Adjust to ensure the border is visible on all sides
    width: `calc(100% + 2px)`, // Adjust to ensure the border is visible on all sides
    height: `calc(100% + 2px)`, // Adjust to ensure the border is visible on all sides
    clipPath: `polygon(
      ${topLeft.x}% ${topLeft.y}%, 
      ${topRight.x}% ${topRight.y}%, 
      ${bottomRight.x}% ${bottomRight.y}%, 
      ${bottomLeft.x}% ${bottomLeft.y}%
    )`,
    border: '1px solid #fff',
    boxSizing: 'border-box',
    pointerEvents: 'none' // Ensure the border element does not interfere with interactions
  };

  return (
    <div className={className} style={style}>
      {/* <div style={borderStyle}></div> */}
      {children}
    </div>
  );
};

Rectangle.propTypes = {
  topLeft: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }).isRequired,
  topRight: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }).isRequired,
  bottomLeft: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }).isRequired,
  bottomRight: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }).isRequired
};

export default Rectangle;